<template>
  <div>
    <form @submit.prevent="clickOpenLogin">
      <div id="content" class="colM">
        <div style="text-align:center">
          <img  :src="status ? img_url.img_checked : img_url.img_close" class="resize" >
        </div>
        <h1 style="text-align:center; font-weight: bold; font-family: Tahoma">{{ status ? $t('registration.email_title_c1') : $t('registration.email_title_c4') }}</h1>
        <p style="color:black;">{{ status ? $t('registration.email_title_c2') : $t('registration.email_title_c5') }}</p>
        <p style="color:black;">{{ status ? $t('registration.email_title_c3') : $t('registration.email_title_c6') }}</p>
        <br class="clear">
        <div style="text-align:center">
          <input type="submit" :value="$t('common.sign_in')" />
        </div>
        <br class="clear">
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import configuration from "@/lib/config";
// import utils from '@/lib/utils'

export default {
  name: 'EmailActivated',
  data() {
    return {
      img_url: configuration.imgUrlConfig,
      uidb64: null,
      token: null,
      messages: {
        email_activated: "Customer is not empty",
        the_email_is_no_longer_valid: "Status is not empty",
        user_does_not_exist: "Use does not exist"
      },
      status:true
    };
  },
  computed: {
    ...mapGetters([])
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ACCOUNT_EMAIL_ACTIVATED",
      "ON_SHOW_TOAST"]),
    clickOpenLogin: function(){
      this.$router.push({
        name: "Login",
      });
    }
  },
  components: {
  },
  mounted() {
    let body = document.getElementsByTagName("BODY")[0];
    body.className = "login-page hold-transition";
    this.uidb64 = this.$route.params.uidb64;
    this.token = this.$route.params.token;

    let payload = {
      uidb64: this.uidb64,
      token: this.token
    }

    this.ACCOUNT_EMAIL_ACTIVATED(payload).then(
      function() {
        this.SUCCESS_TOAST()
        // this.$router.push({ name: "Login" });
        this.status = true
      }.bind(this)
    )
    .catch(
      function(error) {
        this.ON_SHOW_TOAST({
          message: this.messages[error.response.data.message],
          styleType: "danger"
        });
        this.status = false
      }.bind(this)
    )
  }
}

</script>

<style scoped>
@import "../../styles/login_style.css";
@import "font-awesome/css/font-awesome.min.css";

h1 {
  margin: 0 0 20px;
  font-weight: 300;
  font-size: 20px;
  color: black;
}

.resize {
  height: auto;
  width: auto;
  max-width: 100px;
  max-height: 100px;
}

#content {
  font-family: Tahoma
}

</style>


// WEBPACK FOOTER //
// src/views/Account/EmailActivated.vue